import {ModuleWithProviders, NgModule} from "@angular/core";
import {ToastService} from "./toast.service";
// BUG: do not fix path, see https://github.com/dherges/ng-packagr/issues/734
import {NModernToasterComponent} from "./components/n-modern-toaster.component";

import {CommonModule} from "@angular/common";
import {DEFAULT_TOAST_LANG, N_TOAST_LANG} from "./toastLang";

const TOASTS_DIRECTIVES = [
  NModernToasterComponent
];

@NgModule({
  declarations: [
    TOASTS_DIRECTIVES
  ], // directives, components, and pipes owned by this NgModule
  imports: [
    CommonModule
  ],
  providers: [],
  entryComponents: [
    TOASTS_DIRECTIVES
  ]
})
export class NToastsModule {
  static forRoot(): ModuleWithProviders<NToastsModule> {
    return {
      ngModule: NToastsModule,
      providers: [
        ToastService,
        {provide: N_TOAST_LANG, useValue: DEFAULT_TOAST_LANG}
      ]
    };
  }
}
